import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../../component-text';
import { forwardRef } from 'react';
export const RatingInformationText = forwardRef(({ disabled, ...props }, ref) => {
    return (_jsx(Text, { variant: "default", size: "xs", emphasis: disabled ? 'low' : 'medium', color: "surface-onBase-50", ...props, ref: ref }));
});
RatingInformationText.displayName = 'RatingInformationText';
